module.exports = __webpack_public_path__ + "root-b33b72b3/XING-Sans-Bold-Italic-1b8d64e6b1a944bb1d8040a38f63b2f4.woff2";